"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidDateValue = isValidDateValue;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _getTime = _interopRequireDefault(require("date-fns/getTime"));

var _date = require("../../utils/date");

var _dateFns = _interopRequireDefault(require("rc-picker/lib/generate/dateFns"));

var _generatePicker = _interopRequireDefault(require("antd/es/date-picker/generatePicker"));

//import "antd/es/date-picker/style/index";
var DatePicker = (0, _generatePicker.default)(_dateFns.default);

var RuleEditorDate = function RuleEditorDate(_ref) {
  var atom = _ref.atom,
      value = _ref.value,
      setValue = _ref.setValue;
  return /*#__PURE__*/_react.default.createElement(DatePicker, {
    allowClear: false,
    onChange: function onChange(date, dateString) {
      setValue(dateString);
    },
    value: (0, _date.parseDateString)(value || atom.default),
    format: "YYYY-MM-DD"
  });
};

var _default = RuleEditorDate;
exports.default = _default;

function isValidDateValue(atom) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      value = _ref2.value;

  return atom.type === "date" && typeof value === "string" && !isNaN((0, _getTime.default)((0, _date.parseDateString)(value)));
}